module.exports = __webpack_public_path__ + "assets/SF-logo-00dff52f.png";